export default __webpack_public_path__ + "static/media/mo_background@3x.db3477c6.png";